module.exports = __webpack_public_path__ + "img/logo-j2p-small.1c5306a3.png";